module.exports = __webpack_public_path__ + "img/sample-banner-2.ca7a1b55.jpg";